/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 10/11/21
 */

import {
    ArrayLayoutProps,
    CellProps,
    CombinatorRendererProps,
    ControlProps,
    LayoutProps,
    OwnPropsOfRenderer,
    StatePropsOfControlWithDetail,
} from '@jsonforms/core';
import omit from 'lodash/omit';
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';

type JsonFormsPropTypes =
    | ControlProps
    | CombinatorRendererProps
    | LayoutProps
    | CellProps
    | ArrayLayoutProps
    | StatePropsOfControlWithDetail
    | OwnPropsOfRenderer;

const jsonFormIgnoreProps = ['handleChange'];
const jsonFormProps = ['schema', 'uischema', 'renderers', 'cells', 'uischemas'];

interface AreEqualConfig {
    ignore?: string[];
    shallow?: string[];
}

const configuredAreEqual =
    ({ ignore, shallow }: AreEqualConfig) =>
    (prevProps: JsonFormsPropTypes, nextProps: JsonFormsPropTypes) => {
        const ignoreProps = ignore || [];
        const shallowProps = shallow || [];

        const prev = omit(prevProps, [...jsonFormIgnoreProps, ...jsonFormProps, ...ignoreProps, ...shallowProps]);
        const next = omit(nextProps, [...jsonFormIgnoreProps, ...jsonFormProps, ...ignoreProps, ...shallowProps]);
        return (
            isEqual(prev, next) &&
            [...jsonFormProps, ...shallowProps].every(
                (propName) => get(prevProps, propName) === get(nextProps, propName),
            )
        );
    };

export default configuredAreEqual;
